import { convertMoneyInputFormatToFloat } from '@/Utils/FnUtils';
import { EMissionType } from '../constants';
import type { CreateMissionFormType, MissionByManager } from '../types';

const toMoneyFormValue = (value: number) =>
  convertMoneyInputFormatToFloat(String(Math.round(value * 100)));

/**
 * Converte a resposta de `GET /missions/:id/by-manager` para o formato do
 * formulário de criação, reutilizado pelo {@link ConfirmMissionModal}.
 */
export const mapMissionByManagerToFormValues = (
  mission: MissionByManager,
): CreateMissionFormType => {
  const start = new Date(mission.startDate);
  const end = new Date(mission.endDate);
  const [level01, level02, level03] = mission.rewardLevels;

  return {
    startDate: start,
    startTime: start,
    endDate: end,
    endTime: end,
    targetAudience: mission.type,
    cityIds:
      mission.type === EMissionType.CITY
        ? mission.cities?.map(city => city._id) ?? []
        : [],
    deliverymanIds: [],
    deliverymanCsv: null,
    missionName: mission.name,
    budget: toMoneyFormValue(mission.budget),
    objective01: level01 ? String(level01.conditionValue) : '',
    objective02: level02 ? String(level02.conditionValue) : '',
    objective03: level03 ? String(level03.conditionValue) : '',
    reward01: level01 ? toMoneyFormValue(level01.rewardValue) : '',
    reward02: level02 ? toMoneyFormValue(level02.rewardValue) : '',
    reward03: level03 ? toMoneyFormValue(level03.rewardValue) : '',
    missionTitle: mission.title,
    missionDescription: mission.description,
  };
};
